import { createSelector } from 'reselect';
import { subselect } from './root';
import { propertiesSelector } from './properties';

const itemsSelector = createSelector([propertiesSelector], ({ content = [] }) =>
  content.clips.length ? content.clips : [],
);

export const viralItemsSelector = subselect(itemsSelector);
